'use strict';

import angular from 'angular';

const denmark = 'DK';
const country = (window.SA || {}).country;

function remarketingFactory(analytics) {
  'ngInject';

  return {
    init: function () {

      // Track event only if user is from denmark (by ip)
      // User for adwords remarketing
      if (country && country === denmark) {
        analytics.track('RemarketingDK', {
          category: 'Remarketing'
        });
      }
    }
  };
}

export default angular
  .module('services.remarketing', [])
  .factory('remarketing', remarketingFactory)
  .name;



// WEBPACK FOOTER //
// ./app/src/services/remarketing.service.js